import { render } from "./SoaReceiverNotif.vue?vue&type=template&id=6356787c&scoped=true"
import script from "./SoaReceiverNotif.vue?vue&type=script&lang=js"
export * from "./SoaReceiverNotif.vue?vue&type=script&lang=js"

import "./SoaReceiverNotif.vue?vue&type=style&index=0&id=6356787c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6356787c"]])

export default __exports__